<template lang="pug">
	.creative--folders.flex-col
		creative-folder(v-if="folders.length && expandedStates", v-for="folder in sortFolders(folders)", :folder="folder", :expandedStates="expandedStates", @save="onFolderSave", @delete="onFolderDelete", @create="v => createFolder(v)")
		Popup(v-if="newFolderPopup.visible", :popupVisible="newFolderPopup.visible", :width="340", :height="140")
			.flex-col.space
				.flex-col.field
					.font-small.upper.grey {{$tCaption('Folder name')}}
					DxTextBox(:value.sync="newFolderPopup.newFolderName")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="newFolderPopup.visible = false")
				DxButton(:text="$tCaption('Create', '@actions')", type="success", @click="commitCreateFolder")
		Loader(v-if="isLoading", text="", :fullscreen="true")
		Popup(v-if="selectFolderPopup.visible", :popupVisible="selectFolderPopup.visible", :width="340", :height="140")
			.flex-col.space
				.flex-col.field
					.font-small.upper.grey {{$tCaption('Folder')}}
					DxDropDownBox(
						:value.sync="selectFolderPopup.folderId || 'root'"
						:opened.sync="selectFolderPopup.isTreeBoxOpened"
						:show-clear-button="true"
						:data-source="allFoldersPlain"
						value-expr="Oid"
						display-expr="Name"
						:placeholder="$tCaption('Select a value...')"
					)
						template(v-slot:content="{ data }")
							DxTreeView.compact(
								:data-source="allFoldersPlain"
								:select-by-click="true"
								data-structure="plain"
								key-expr="Oid"
								parent-id-expr="ParentId"
								selection-mode="single"
								display-expr="Name"
								@content-ready="$event.component.selectItem(selectFolderPopup.folderId || 'root')"
								@item-selection-changed="onTreeViewItemSelectionChanged($event)"
								@item-click="onTreeItemClick($event)"
							)
			template(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="selectFolderPopup.visible = false")
				DxButton(:text="$tCaption('OK', '@actions')", type="success", @click="commitFolderSelect")
</template>
<script>
	import _ from 'lodash';
	import DxButton from 'devextreme-vue/button';
	import Popup from 'app-core/Popup.vue';
	import DxTextBox from 'devextreme-vue/text-box';
	import storage from 'storage';
	import Loader from 'app-core/Loader.vue';
	import DxDropDownBox from 'devextreme-vue/drop-down-box';
	import DxTreeView from 'devextreme-vue/tree-view';

	export default {
		translationCategory: 'creative.CreativeFolders',
		name: 'creative--folders',
		components: {
			DxButton, Popup, DxTextBox, Loader, DxDropDownBox, DxTreeView
		},
		data() {
			return {
				expandedStates: storage.prop('creative-folders-expanded-state', void 0, {}),
				newFolderPopup: {
					visible: false,
					parentFolder: null,
					newFolderName: null
				},
				isLoading: 0,
				loadedFolders: [],
				selectedFolder: storage.prop('creative-folders-selected', void 0, null),
				selectFolderPopup: {
					visible: false,
					folderId: null,
					isTreeBoxOpened: false
				}
			}
		},
		computed: {
			allFolders() {
				const result = [];
				let processFolders = (folders, parentFolder) => {
					folders?.map(f => {
						result.push({
							folder: f,
							parentFolder
						});
						processFolders(f.Items, f);
					})
				}
				processFolders(this.folders);
				return result;
			},
			allFoldersPlain() {
				return this.allFolders.map(f => ({
					...f.folder,
					Oid: f.folder.Oid || 'root',
					ParentId: f.folder.Oid ? (f.folder.ParentId && this.allFolders.some(s => s.folder?.Oid === f.folder.ParentId) ? f.folder.ParentId : 'root') : null
				}));
			},
			folders() {
				return [
					{ 
						Oid: null,
						Name: this.$tCaption('Root'),
						Items: this.loadedFolders
					}
				];
			}
		},
		watch: {
			
		},
		mounted() {
			if (__DEBUG__)
				window.creativeFolders = this;
			this.loadFolders();
			this.$eventsBus.$on('creative-folder-select', this.onEventsBusFolderSelect);
		},
		destroyed() {
			this.$eventsBus.$off('creative-folder-select', this.onEventsBusFolderSelect);
		},
		methods: {
			onTreeItemClick() {
				this.selectFolderPopup.isTreeBoxOpened = false;
			},
			onTreeViewItemSelectionChanged(e) {
				this.selectFolderPopup.folderId = e.component.getSelectedNodeKeys()[0];
			},
			onEventsBusFolderSelect(folder) {
				if (__DEBUG__)
					console.debug('onEventsBusFolderSelect', { folder });
				this.selectedFolder.value = folder?.Oid;
				this.$emit('select', folder);
			},
			onFolderSave(folder) {
				this.isLoading++;
				this.createUpdateFolder(folder).finally(() => this.isLoading--);
			},
			onFolderDelete(folder) {
				const removeFolder = () => {
					this.isLoading++;
					this.$Data.getExternalApi('CreativeFolder/DeleteCreativeFolder', `id=${folder?.Oid}`).finally(() => this.isLoading--);
					const parentItems = this.allFolders.find(f => f.folder === folder)?.parentFolder?.Items || this.loadedFolders;
					if (parentItems) {
						const idx = parentItems.findIndex(f => f.Oid === folder.Oid);
						if (idx > -1) {
							parentItems.splice(idx, 1);
						}
						if (folder.Items?.length) {
							this.loadedFolders.push(...folder.Items);
						}
					}
				}
				const haveSubFolders = folder.Items?.length ? this.$tCaption('This folder contains sub-folders. They will be moved to the root. ') : '';
				this.$confirmMessage({
					title: this.$tCaption('Confirm action', '@actions'),
					text: haveSubFolders + this.$tCaption('Do you want to remove folder?'),
					handler: () => {
						removeFolder();
					}
				});
			},
			sortFolders(items) {
				return _.orderBy(items, ['Name']);
			},
			createFolder(parentFolder) {
				this.newFolderPopup.visible = false;
				this.newFolderPopup.parentFolder = parentFolder;
				this.newFolderPopup.newFolderName = this.$tCaption('New folder');
				setImmediate(() => this.newFolderPopup.visible = true);
			},
			commitCreateFolder() {				
				const newFolder = {
					Oid: null,
					ParentId: this.newFolderPopup.parentFolder?.Oid || null,
					Name: this.newFolderPopup.newFolderName,
					Items: []
				};

				const parentFolder = this.newFolderPopup.parentFolder;
				if (__DEBUG__)
					console.debug('commitCreateFolder', { newFolder, parentFolder });
				if (parentFolder) {
					parentFolder.Items.push(newFolder);
					parentFolder.__instance.expanded = true;
				}
				this.isLoading++;
				this.createUpdateFolder(newFolder)
					.then(r => {
						if (!newFolder.Oid) {
							newFolder.Oid = r.Data?.Oid;
						}
					})
					.finally(() => this.isLoading--);
				this.newFolderPopup.visible = false;
			},
			createUpdateFolder(folder) {
				return this.$Data.postExternalApi('CreativeFolder/CreateUpdateCreativeFolder', folder);
			},
			loadFolders() {
				this.isLoading++;
				this.$Data.getExternalApi('CreativeFolder/GetCreativeFolders', '', 9999).then(r => {
					this.loadedFolders = this.getFoldersFromRawResponse(r.Results);
					const folder = this.allFolders.find(f => f?.folder?.Oid == this.selectedFolder.value)?.folder;
					this.$nextTick(() => {
						if (folder) {
							this.$eventsBus.$emit('creative-folder-select', folder);
						}
					});
					if (__DEBUG__)
						console.debug('Loaded', { folder });
				}).finally(() => this.isLoading--);
			},
			getFoldersFromRawResponse(folders) {
				folders.map(f => this.$set(f, 'Items', []));
				const result = folders.filter(f => !f.ParentId || !folders.some(s => s.Oid === f.ParentId));
				const processChildFolders = (parent) => {
					parent.Items = folders.filter(f => f.ParentId == parent.Oid);
					parent.Items.map(f => processChildFolders(f));
				}
				result.map(f => processChildFolders(f));
				return result;
			},
			selectFolder(currentFolderId, callback) {
				this.selectFolderPopup.folderId = currentFolderId || null;
				this.selectFolderPopup.visible = false;
				this.$selectFolderCallback = callback;
				this.$nextTick(() => {
					this.selectFolderPopup.visible = true;
				});
			},
			commitFolderSelect() {
				this.selectFolderPopup.visible = false;
				if (this.$selectFolderCallback) {
					this.$selectFolderCallback(this.selectFolderPopup.folderId === 'root' ? null : this.selectFolderPopup.folderId);
					delete this.$selectFolderCallback;
				}
			}
		}
	};
</script>
<style lang="scss">
	@import "main/themes/generated/variables.base.scss";
	.creative--folders {
		padding: 10px 5px 10px 10px;
		background: #f9f9f9;
		border-right: 1px solid #dedede;
		border-top: 1px solid #dedede;
		border-bottom: 1px solid #dedede;
		width: 280px;
		position: relative;

		.folder-button {
			padding: 4px 8px;
			background: #e8e8e8;
			border-radius: 4px;
			cursor: pointer;
			transition: 0.3s;

			&:hover {
				background: $base-accent;
				color: $base-bg;
			}
		}
	}
</style>